import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchUserTypes } from 'Redux/Admin/HabitManager/UserTypes/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IUserType } from 'Redux/Admin/HabitManager/UserTypes/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const SLUG = "hm-user-types";

const columns: TableColumnsType<IUserType> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/${SLUG}/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
];

const UserTypes = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const user = params.get('user');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchUserTypes);

  useEffect(() => {
    dispatch(fetchUserTypes({ user, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [user, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IUserType>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/${SLUG}/new`}
      filters={filterConfigs}
    />
  );
}

export default UserTypes;
